/* @flow */

import { useGetUserQuery } from 'src/shared/app/base/api/endpoint/usersEndpoint';
import useEventId from 'src/shared/domain/event/hook/useEventId';

const useUser = (userId: number | 'me') => {
  const eventId = useEventId();
  return useGetUserQuery({ id: userId, eventId });
};

export default useUser;
